
import { defineComponent, ref } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  name: "sign-up",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const store = useStore();
    const router = useRouter();

    const submitButton = ref<HTMLElement | null>(null);

    const registration = Yup.object().shape({
      university: Yup.string().required().label("University"),
      userrole: Yup.string().required().label("User Type"),
      title: Yup.string().required().label("Title"),
      firstname: Yup.string().required().label("First Name"),
      middlename: Yup.string().label("Middle Name"),
      lastname: Yup.string().required().label("Last Name"),
     email: Yup.string()
            .min(4)
            .required()
            .email()
            .label("Email")
            .matches(
              /^[a-zA-Z0-9_.+-]+@(gannon|ursuline)\.edu$/, 
              'Please enter Gannon or Ursuline email address'
            ),
      // email: Yup.string().min(4).required().email().label("Email"),
      // email: Yup.string().min(4).required().email().label("Email").matches(/^[a-zA-Z0-9_.+-]+@gannon\.edu$/, 'Please enter Gannon email address'),
      phonenumber: Yup.string().required().label("Phone Number"),
      password: Yup.string()
        .min(6, "Must Contain 6 Characters")
        .required()
        .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Must contain at least one number')
        .matches(/[^A-Za-z0-9]/, 'Must contain at least one special character')
        .label("Password"),
      //password: Yup.string().min(6).required().label("Password"),
      cpassword: Yup.string()
        .min(6)
        .required()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .label("Password Confirmation"),
    });

    const onSubmitRegister = (values) => {
      // Clear existing errors
      store.dispatch(Actions.LOGOUT);

      // Activate indicator
      submitButton.value?.setAttribute("data-kt-indicator", "on");

      // Send login request
      store
        .dispatch(Actions.REGISTER, values)
        .then(() => {
          Swal.fire({
            text: "Your account has been created and sent for validation. You will receive a confirmation email once your account is validate and approved.",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            submitButton.value?.removeAttribute("data-kt-indicator");
            // Go to page after successfully login
            router.push({ name: "sign-in" });
          });
        })
        .catch(() => {
          submitButton.value?.removeAttribute("data-kt-indicator");
          Swal.fire({
            text: store.getters.getErrors[0],
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    };

    return {
      onSubmitRegister,
      registration,
      submitButton,
    };
  },
});
